import { createSlice } from "@reduxjs/toolkit";


const notification = createSlice({
    name : 'notification',
    initialState : {
        notificationIsOpen : false,
        data:[]
    },
    reducers : {
        notificationDrawerOpen : (state) =>{
            state.notificationIsOpen = true
        },
        notificationDrawerClose : (state) =>{
            state.notificationIsOpen = false
        },
        setNotification: (state:any, action:any) => {
            state.data.push(action.payload)
        }
    }
})

export const { notificationDrawerOpen, notificationDrawerClose, setNotification } = notification.actions;

export default notification.reducer;